import { useState } from 'react';
import { useSiteContent } from '../../../hooks/useSiteContent';

export default function ServicesSection() {
  const { content, loading } = useSiteContent();
  const [currentSlide, setCurrentSlide] = useState(0);

  if (loading || !content) {
    return (
      <section id="services" className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-600 mx-auto"></div>
        </div>
      </section>
    );
  }

  const services = [...content.services].sort((a, b) => a.order - b.order);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % services.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + services.length) % services.length);
  };

  const getColorClass = (index: number) => {
    const colors = [
      'from-blue-500 to-blue-600',
      'from-purple-500 to-purple-600',
      'from-pink-500 to-pink-600',
      'from-green-500 to-green-600',
      'from-blue-600 to-indigo-600',
      'from-orange-500 to-orange-600'
    ];
    return colors[index % colors.length];
  };

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nuestros Servicios
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Soluciones completas de marketing digital para hacer crecer tu negocio
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 overflow-hidden cursor-pointer"
            >
              <div className={`h-2 bg-gradient-to-r ${getColorClass(index)}`}></div>
              <div className="p-8">
                <div className={`w-16 h-16 bg-gradient-to-r ${getColorClass(index)} rounded-lg flex items-center justify-center mb-4`}>
                  <i className={`${service.icon} text-3xl text-white w-8 h-8 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600">
                  {service.short_description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
